var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function PlayerBffResponseFormatter(response) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const json = yield response.json();
            if (!response.ok) {
                throw json;
            }
            return json;
        }
        catch (e) {
            const errorMessage = parseError(e);
            throw {
                statusCode: e.statusCode || "ApplicationError",
                description: errorMessage
            };
        }
        function parseError(error) {
            if (!!error.metadata) {
                return error.metadata["PromotionCode"] || error.metadata["RequestContext.PlayerId"];
            }
            return error.message;
        }
    });
}
//# sourceMappingURL=PlayerBffResponseFormatter.js.map